<template>
  <b-col lg="12">
    <b-col>
      <div class="demo-inline-spacing">
        <b-button
            class="mr-2 bg-secondary bg-darken-2 border-0"
            :to="{ name: 'pedidos-vendas' }"
            v-if="botoesExibir.includes('Voltar')"
            @click="voltar"
        >
          <feather-icon icon="ArrowLeftCircleIcon" size="18"/>
          Voltar
        </b-button>
        <b-button
            class="mr-2 bg-warning bg-darken-2 border-0"
            v-if="botoesExibir.includes('Alterar')"
        >
          <feather-icon icon="Edit2Icon" size="18"/>
          Alterar
        </b-button>
        <b-button
            class="mr-2 bg-dark bg-darken-2 border-0"
            v-if="botoesExibir.includes('Finalizar')"
        >
          <feather-icon icon="CheckCircleIcon" size="18"/>
          Finalizar
        </b-button>
        <b-button
            class="mr-2 bg-danger bg-darken-2 border-0"
            v-if="botoesExibir.includes('Cancelar')"
        >
          <feather-icon icon="XCircleIcon" size="18"/>
          Cancelar
        </b-button>
        <b-button
            class="mr-2 bg-success bg-darken-2 border-0"
            v-if="botoesExibir.includes('Copiar')"
        >
          <feather-icon icon="CopyIcon" size="18"/>
          Copiar
        </b-button>
<!--        <b-button-->
<!--            class="mr-2 bg-warning bg-darken-2 border-0"-->
<!--        >-->
<!--          <feather-icon icon="AlignJustifyIcon" class="rotate-icon" size="18"/>-->
<!--          Boleto-->
<!--        </b-button>-->
      </div>
    </b-col>
    <b-col md="12" class="mt-2">
      <b-card no-body>
        <b-card-header :header-bg-variant="`secondary bg-lighten-5`" class="w-100">
                    <b-card-title>Pedidos</b-card-title>
          <div class="demo-inline-spacing">
             <h3>
               <b-badge size="xl" variant="success">
                 NR Pré-Pedido : {{getCapaPedido.pedidoid}}
               </b-badge>
             </h3>
            <h3>
              <b-badge variant="success" >
              Pedido ERP : {{getCapaPedido.pedidonumerointegracao}}
              </b-badge>
            </h3>
          </div>
        </b-card-header>
        <b-tabs card pills nav-class="nav-pill-primary">
          <b-tab>
            <template #title>
              <feather-icon icon="PocketIcon"/>
              <span>Condições</span>
            </template>
            <b-row>
              <b-col class="mt-2 mb-2">
                <b-row class="mb-12">
                  <b-col md="3">
                    <b-form-group label="NR Pré-Pedido">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.pedidoid" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group label="Pedido ERP">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.pedidonumerointegracao" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Status">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.pedidositsales" disabled/>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Representante">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.representanteid" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Nome representante">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.representantenome" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group label="Estabelecimento">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.estabelecimentoid"
                                    disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Estabelecimento Razãosocial">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.estabelecimentorazaosocial"
                                    disabled/>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Cliente">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.clienteiderp" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Cliente Razãosocial">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.clienterazaosocial"
                                    disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group label="Condição de Pagamento">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.condicaopagamentoid"
                                    disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Condição de Pagamento Descrição">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.condicaoPagamentoDescricao"
                                    disabled/>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Tabela de preço">
                      <b-form-input type="number" placeholder="" v-model="getCapaPedido.clienteiderp" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Cliente Razãosocial">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.clienterazaosocial"
                                    disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Usuário">
                      <b-form-input type="text" placeholder="" v-model="getCapaPedido.usuario_nome" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="2">
                    <b-form-group label="Data Emissão">
                      <b-form-input type="date" placeholder="" v-model="getCapaPedido.pedidositcreditodata" disabled/>
                    </b-form-group>
                  </b-col>

                  <b-col md="2">
                    <b-form-group label="Nr. OC">
                      <b-form-input type="number" placeholder="" disabled/>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="Prioridade do pedido">
                      <b-form-input type="text" placeholder="" disabled/>
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group label="Observações">
                      <b-form-textarea
                          id="textarea-rows"
                          placeholder="Observações...."
                          v-model="getCapaPedido.pedidoobservacoes"
                          rows="8"
                          disabled
                      />
                    </b-form-group>
                  </b-col>
<!--                  <b-col md="12">-->
<!--                    <b-form-group label="Observações">-->
<!--                      <b-form-textarea-->
<!--                          id="textarea-rows"-->
<!--                          placeholder="Tall textarea"-->
<!--                          rows="8"-->
<!--                      />-->
<!--                    </b-form-group>-->
<!--                  </b-col>-->
                </b-row>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
              <b-col class="mt-2 mb-2">
                <b-card no-body>
                  <b-card-header :header-bg-variant="`secondary bg-lighten-5`" class="w-100">
                    <b-card-title>Total de Pedido</b-card-title>
                  </b-card-header>
                  <b-row class="mb-12 mt-2">
                    <b-col md="6">
                      <b-form-group label="Valor Total Produtos">
                        <b-form-input type="text" placeholder="" v-model="getCapaPedido.pedidovalortotal" disabled/>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group label="Quantidade total">
                        <b-form-input type="number" placeholder="" disabled/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon icon="ListIcon"/>
              <span>Itens</span>
            </template>
            <b-table
              :items="getItensPedido"
              :fields="fields"
              striped
              responsive
              :striped="true"
              :bordered="true"
              :hover="true"
            >
              <template #cell(mostrar_detalhes)="row">
                <b-form-checkbox
                    v-model="row.detailsShowing"
                    plain
                    class="vs-checkbox-con"
                    @change="row.toggleDetails"
                >
          <span class="vs-checkbox">
            <span class="vs-checkbox--check">
              <i class="vs-icon feather icon-check"/>
            </span>
          </span>
                  <span class="vs-label">{{ row.detailsShowing ? 'Ocultar' : 'Mostrar' }}</span>
                </b-form-checkbox>
              </template>

              <template #row-details="row">
                <b-card>
                  <b-table
                      responsive="sm"
                      :fields="fieldsSub"
                      :items="row.item.itens"
                      :striped="true"
                      :bordered="true"
                      :hover="true"
                      table-variant="outline-secondary"
                  />

                  <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="row.toggleDetails"
                  >
                    Ocultar Detalhes
                  </b-button>
                </b-card>
              </template>

              <template #cell(editar)="data">
                <b-button
                    size="sm"
                    class="mr-2 bg-primary bg-darken-2 border-0"
                >
                  <feather-icon icon="EditIcon" class="rotate-icon"/>
                </b-button>
              </template>

              <template #cell(excluir)="data">
                <b-button
                    size="sm"
                    class="mr-2 bg-danger bg-darken-5 border-0"
                >
                  <feather-icon icon="TrashIcon"/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon icon="TruckIcon"/>
              <span>Entrega</span>
            </template>
            <b-row>
              <b-col md="2">
                <b-form-group label="Data Estimada Entrega">
                  <b-form-input type="date" placeholder="" v-model="getCapaPedido.pedidodataentrega" disabled/>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Endereço">
                  <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.clienteendereco" disabled/>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="CEP">
                  <b-form-input type="number" placeholder="" v-model="getEnderecoEntrega.clienteenderecocep" disabled/>
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Bairro">
                  <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.clienteenderecobairro" disabled/>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Cidade">
                  <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.clienteenderecocidade" disabled/>
                </b-form-group>
              </b-col>
              <b-col md="1">
                <b-form-group label="Estado">
                  <b-form-input type="text" placeholder="" v-model="getEnderecoEntrega.ufid" disabled/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-col>
  </b-col>
</template>

<script>
import {
  BTabs,
  BTab,
  BCardText,
  BCard,
  BCol,
  BCardHeader,
  BFormSelect,
  BFormInput,
  BRow,
  BFormGroup, BButton, BTable, BFormCheckbox, BCardFooter,
} from 'bootstrap-vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import { mapActions, mapGetters } from 'vuex';
import Store from '@/store';

export default {
  components: {
    BCardFooter,
    BButton,
    BFormGroup,
    BRow,
    BFormInput,
    BFormSelect,
    BCardHeader,
    BCol,
    BCard,
    BCardText,
    BTabs,
    BTab,
    BTable,
    BFormCheckbox,
    AppCollapse,
    AppCollapseItem,
  },
  data: () => ({
    collapseType: 'border',
    fields: ['mostrar_detalhes', { key: 'DescricaoMarca', label: 'Marca', sortable: true }, {
      key: 'referencia',
      label: 'Referência',
      sortable: true,
    }, { key: 'DescricaoEmbalagem', label: 'Embalagem', sortable: true }, {
      key: 'sequencia',
      label: 'Sequência',
      sortable: true,
    }, { key: 'PrecoUnitario', label: 'Valor Unitario', sortable: true }, {
      key: 'Qtde',
      label: 'Quantidade',
      sortable: true,
    }, { key: 'ValorTotal', label: 'Valor Total', sortable: true }, {
      key: 'editar',
      label: 'Editar',
      sortable: true,
    }, { key: 'excluir', label: 'Excluir', sortable: true }],
    fieldsSub: [
      { key: 'itemId', label: 'Código', sortable: true },
      { key: 'item_descricao', label: 'Descrição', sortable: true },
      { key: 'marca', label: 'Marca', sortable: true },
      { key: 'des_cor', label: 'Cor', sortable: true },
      { key: 'embalagem', label: 'Embalagem', sortable: true },
      { key: 'pedidoItemQuantidade', label: 'QTD', sortable: true },
      { key: 'precoUnitario', label: 'Valor Unitario', sortable: true },
      { key: 'valorTotal', label: 'Valor Total', sortable: true },
      { key: 'pedidoItemQuantidadeSaldo', label: 'QTD Saldo', sortable: true },
      { key: 'pedidoItemQuantidadeFaturada', label: 'QTD Faturado', sortable: true },
    ],
  }),
  mounted() {
    this.detalhePedido(this.$route.params.pedidoid, this.$route.params.clienteid);
  },
  methods: {
    ...mapActions('SLS_PedidosVendas', ['setFilters', 'retornaPedidoVendas', 'listarCapaPedido', 'enderecoEntregaPedido', 'retornaItensPedido', 'clearFilters']),
    async detalhePedido(pedidoid, clienteid) {
      await this.listarCapaPedido(pedidoid);
      await this.enderecoEntregaPedido(clienteid);
      await this.retornaItensPedido(pedidoid);
    },
    async voltar() {
      await this.clearFilters();
    },
  },
  computed: {
    ...mapGetters({
      getPedidoVendas: 'SLS_PedidosVendas/getPedidoVendas',
      getCapaPedido: 'SLS_PedidosVendas/getCapaPedido',
      getEnderecoEntrega: 'SLS_PedidosVendas/getEnderecoEntrega',
      getItensPedido: 'SLS_PedidosVendas/getItensPedido',
    }),
    botoesExibir() {
      const statusPedido = this.getCapaPedido?.pedidositsales;
      const botoesPorStatus = {
        CANCELADO: ['Voltar'],
        DIGITADO: ['Voltar', 'Alterar', 'Finalizar', 'Cancelar', 'Copiar'],
        EXCLUIDO: ['Voltar'],
        INTEGRADO: ['Voltar', 'Copiar'],
        RECALCULAR: ['Voltar', 'Cancelar', 'Copiar', 'Recalcular'],
        REJEITADO: ['Voltar', 'Alterar', 'Finalizar', 'Cancelar', 'Copiar'],
        SUBMETIDOS: ['Voltar', 'Copiar'],
      };
      return statusPedido ? botoesPorStatus[statusPedido] : [];
    },
  },
};
</script>
<style scoped>
.rotate-icon {
  transform: rotate(90deg);
}

</style>
